import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=860e20c6&scoped=true&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"
import style0 from "./comment.vue?vue&type=style&index=0&id=860e20c6&lang=stylus&scoped=true&"
import style1 from "./comment.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860e20c6",
  null
  
)

export default component.exports